enum RenderingEngineModeEnum {
  Tiled = 'tiled',
  ContextPool = 'contextPool',
}

export default RenderingEngineModeEnum;
